import React from 'react';
import { styled, theme } from 'twin.macro';
import { ExtraStyle } from '../../Type.component';

type Props = {
  size?: 'large' | 'medium' | 'small';
  color?: string;
  containerStyle?: ExtraStyle;
};

const Container = styled.div(`
  @-webkit-keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  height: 100%;
  width: 100%;
  animation: spin;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-delay: 0;
  animation-iteration-count: infinite;
`);

export default function LoadingIndicator({
  size = 'medium',
  color = theme`colors.primary.500`,
  containerStyle,
}: Props) {
  return (
    <>
      {size === 'large' && (
        <div tw="w-16 h-16 inline-block" css={containerStyle}>
          <Container>
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_38_4" fill="white">
                <path d="M64 32C64 24.9557 61.6756 18.1082 57.3873 12.5196C53.099 6.93102 47.0865 2.91357 40.2822 1.09037C33.4779 -0.732824 26.2622 -0.25988 19.7541 2.43585C13.2461 5.13159 7.80934 9.89946 4.28719 16C0.76504 22.1005 -0.6457 29.1928 0.273764 36.1768C1.19323 43.1609 4.39151 49.6463 9.37258 54.6274C14.3536 59.6085 20.8391 62.8068 27.8232 63.7262C34.8072 64.6457 41.8995 63.235 48 59.7128L44.8 54.1703C39.9196 56.988 34.2458 58.1166 28.6585 57.381C23.0713 56.6454 17.8829 54.0868 13.8981 50.1019C9.91321 46.1171 7.35458 40.9287 6.61901 35.3415C5.88344 29.7542 7.01203 24.0804 9.82975 19.2C12.6475 14.3196 16.9968 10.5053 22.2033 8.34868C27.4098 6.1921 33.1824 5.81374 38.6258 7.2723C44.0692 8.73086 48.8792 11.9448 52.3098 16.4157C55.7405 20.8866 57.6 26.3646 57.6 32H64Z" />
              </mask>
              <path
                d="M64 32C64 24.9557 61.6756 18.1082 57.3873 12.5196C53.099 6.93102 47.0865 2.91357 40.2822 1.09037C33.4779 -0.732824 26.2622 -0.25988 19.7541 2.43585C13.2461 5.13159 7.80934 9.89946 4.28719 16C0.76504 22.1005 -0.6457 29.1928 0.273764 36.1768C1.19323 43.1609 4.39151 49.6463 9.37258 54.6274C14.3536 59.6085 20.8391 62.8068 27.8232 63.7262C34.8072 64.6457 41.8995 63.235 48 59.7128L44.8 54.1703C39.9196 56.988 34.2458 58.1166 28.6585 57.381C23.0713 56.6454 17.8829 54.0868 13.8981 50.1019C9.91321 46.1171 7.35458 40.9287 6.61901 35.3415C5.88344 29.7542 7.01203 24.0804 9.82975 19.2C12.6475 14.3196 16.9968 10.5053 22.2033 8.34868C27.4098 6.1921 33.1824 5.81374 38.6258 7.2723C44.0692 8.73086 48.8792 11.9448 52.3098 16.4157C55.7405 20.8866 57.6 26.3646 57.6 32H64Z"
                stroke={color}
                strokeWidth="8"
                mask="url(#path-1-inside-1_38_4)"
              />
            </svg>
          </Container>
        </div>
      )}
      {size === 'medium' && (
        <div tw="w-11 h-11 inline-block" css={containerStyle}>
          <Container>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_38_5" fill="white">
                <path d="M44 22C44 17.157 42.402 12.4494 39.4538 8.60725C36.5056 4.76508 32.372 2.00308 27.694 0.749632C23.0161 -0.503817 18.0553 -0.178668 13.581 1.67465C9.10666 3.52797 5.36892 6.80588 2.94744 11C0.525965 15.1941 -0.443919 20.0701 0.188213 24.8716C0.820345 29.6731 3.01917 34.1319 6.44365 37.5563C9.86813 40.9808 14.3269 43.1797 19.1284 43.8118C23.9299 44.4439 28.8059 43.474 33 41.0526L30.8 37.242C27.4447 39.1792 23.544 39.9551 19.7027 39.4494C15.8615 38.9437 12.2945 37.1847 9.55492 34.4451C6.81533 31.7055 5.05628 28.1385 4.55057 24.2973C4.04486 20.456 4.82077 16.5553 6.75795 13.2C8.69513 9.8447 11.6853 7.22237 15.2648 5.73972C18.8442 4.25707 22.8129 3.99695 26.5552 4.99971C30.2976 6.00246 33.6045 8.21206 35.963 11.2858C38.3216 14.3595 39.6 18.1256 39.6 22H44Z" />
              </mask>
              <path
                d="M44 22C44 17.157 42.402 12.4494 39.4538 8.60725C36.5056 4.76508 32.372 2.00308 27.694 0.749632C23.0161 -0.503817 18.0553 -0.178668 13.581 1.67465C9.10666 3.52797 5.36892 6.80588 2.94744 11C0.525965 15.1941 -0.443919 20.0701 0.188213 24.8716C0.820345 29.6731 3.01917 34.1319 6.44365 37.5563C9.86813 40.9808 14.3269 43.1797 19.1284 43.8118C23.9299 44.4439 28.8059 43.474 33 41.0526L30.8 37.242C27.4447 39.1792 23.544 39.9551 19.7027 39.4494C15.8615 38.9437 12.2945 37.1847 9.55492 34.4451C6.81533 31.7055 5.05628 28.1385 4.55057 24.2973C4.04486 20.456 4.82077 16.5553 6.75795 13.2C8.69513 9.8447 11.6853 7.22237 15.2648 5.73972C18.8442 4.25707 22.8129 3.99695 26.5552 4.99971C30.2976 6.00246 33.6045 8.21206 35.963 11.2858C38.3216 14.3595 39.6 18.1256 39.6 22H44Z"
                stroke={color}
                strokeWidth="8"
                mask="url(#path-1-inside-1_38_5)"
              />
            </svg>
          </Container>
        </div>
      )}
      {size === 'small' && (
        <div tw="w-6 h-6 inline-block" css={containerStyle}>
          <Container>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_38_6" fill="white">
                <path d="M24 12C24 9.35839 23.1284 6.79059 21.5202 4.69486C19.9121 2.59913 17.6574 1.09259 15.1058 0.40889C12.5542 -0.274809 9.84833 -0.097455 7.4078 0.913445C4.96727 1.92435 2.9285 3.7123 1.6077 6C0.28689 8.2877 -0.242138 10.9473 0.102662 13.5663C0.447461 16.1853 1.64682 18.6174 3.51472 20.4853C5.38262 22.3532 7.81467 23.5525 10.4337 23.8973C13.0527 24.2421 15.7123 23.7131 18 22.3923L16.8 20.3138C14.9698 21.3705 12.8422 21.7937 10.7469 21.5179C8.65174 21.242 6.70609 20.2825 5.21177 18.7882C3.71745 17.2939 2.75797 15.3483 2.48213 13.2531C2.20629 11.1578 2.62951 9.03016 3.68616 7.2C4.7428 5.36984 6.37382 3.93948 8.32624 3.13076C10.2787 2.32204 12.4434 2.18015 14.4847 2.72711C16.5259 3.27407 18.3297 4.47931 19.6162 6.15589C20.9027 7.83247 21.6 9.88671 21.6 12H24Z" />
              </mask>
              <path
                d="M24 12V16H28V12H24ZM18 22.3923L20 25.8564L23.4641 23.8564L21.4641 20.3923L18 22.3923ZM16.8 20.3138L20.2641 18.3138L18.2641 14.8497L14.8 16.8497L16.8 20.3138ZM21.6 12L17.6 12L17.6 16H21.6V12ZM28 12C28 8.47785 26.8378 5.05413 24.6937 2.25982L18.3468 7.12991C19.4189 8.52706 20 10.2389 20 12H28ZM24.6937 2.25982C22.5495 -0.53449 19.5432 -2.54321 16.1411 -3.45481L14.0706 4.27259C15.7716 4.72839 17.2748 5.73275 18.3468 7.12991L24.6937 2.25982ZM16.1411 -3.45481C12.739 -4.36641 9.13111 -4.12994 5.87707 -2.78207L8.93853 4.60896C10.5656 3.93503 12.3695 3.81679 14.0706 4.27259L16.1411 -3.45481ZM5.87707 -2.78207C2.62303 -1.43421 -0.0953322 0.94973 -1.85641 4L5.0718 8C5.95233 6.47487 7.31151 5.2829 8.93853 4.60896L5.87707 -2.78207ZM-1.85641 4C-3.61748 7.05027 -4.32285 10.5964 -3.86312 14.0884L4.06844 13.0442C3.83857 11.2982 4.19126 9.52513 5.0718 8L-1.85641 4ZM-3.86312 14.0884C-3.40339 17.5804 -1.80424 20.8232 0.686291 23.3137L6.34315 17.6569C5.09788 16.4116 4.29831 14.7902 4.06844 13.0442L-3.86312 14.0884ZM0.686291 23.3137C3.17682 25.8042 6.41956 27.4034 9.91158 27.8631L10.9558 19.9316C9.20978 19.7017 7.58841 18.9021 6.34315 17.6569L0.686291 23.3137ZM9.91158 27.8631C13.4036 28.3229 16.9497 27.6175 20 25.8564L16 18.9282C14.4749 19.8087 12.7018 20.1614 10.9558 19.9316L9.91158 27.8631ZM21.4641 20.3923L20.2641 18.3138L13.3359 22.3138L14.5359 24.3923L21.4641 20.3923ZM14.8 16.8497C13.7324 17.4661 12.4913 17.713 11.2691 17.5521L10.2248 25.4837C13.1931 25.8744 16.2073 25.2749 18.8 23.7779L14.8 16.8497ZM11.2691 17.5521C10.0468 17.3912 8.91189 16.8315 8.0402 15.9598L2.38335 21.6167C4.5003 23.7336 7.25663 25.0929 10.2248 25.4837L11.2691 17.5521ZM8.0402 15.9598C7.16851 15.0881 6.60881 13.9532 6.44791 12.7309L-1.48365 13.7752C-1.09288 16.7434 0.266393 19.4997 2.38335 21.6167L8.0402 15.9598ZM6.44791 12.7309C6.287 11.5087 6.53388 10.2676 7.15026 9.2L0.222055 5.2C-1.27486 7.79273 -1.87442 10.8069 -1.48365 13.7752L6.44791 12.7309ZM7.15026 9.2C7.76663 8.13241 8.71806 7.29803 9.85697 6.82627L6.79551 -0.564762C4.02957 0.580925 1.71897 2.60727 0.222055 5.2L7.15026 9.2ZM9.85697 6.82627C10.9959 6.35452 12.2586 6.27176 13.4494 6.59082L15.5199 -1.13659C12.6281 -1.91145 9.56144 -1.71045 6.79551 -0.564762L9.85697 6.82627ZM13.4494 6.59082C14.6401 6.90987 15.6923 7.61293 16.4428 8.59094L22.7896 3.72084C20.9671 1.34568 18.4118 -0.361732 15.5199 -1.13659L13.4494 6.59082ZM16.4428 8.59094C17.1932 9.56894 17.6 10.7672 17.6 12L25.6 12C25.6 9.00617 24.6121 6.09601 22.7896 3.72084L16.4428 8.59094ZM21.6 16H24V8H21.6V16Z"
                fill={color}
                mask="url(#path-1-inside-1_38_6)"
              />
            </svg>
          </Container>
        </div>
      )}
    </>
  );
}
